import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const TranslationText = (props) => {

    const currentUser = useRecoilValue(atoms.currentUser);
    const defaultLanguageId = 2; /* ENGLISH */
    const languageId = typeof currentUser.LanguageID != 'undefined' ? currentUser.LanguageID : defaultLanguageId;
    const isInEditorMode = useRecoilValue(atoms.isInTranslationEditor);
    const namespace = 'Sandhills.TradeSites.MVC';
    const translatedText = translator.translate(props.tKey, props.replaceValues, languageId);
    const attributes = {
        'data-name': isInEditorMode ? 'translationWithKeyname' : null,
        'keyname': isInEditorMode ? props.tKey : null,
        'englishphrase': isInEditorMode ? translator.translate(props.tKey, null, 2) : null,
        'namespace': isInEditorMode ? namespace : null,
        'langid': isInEditorMode ? languageId : null
    };

    return (
        <span {...attributes} dangerouslySetInnerHTML={{ __html: translatedText }}></span>
    );
};

export default TranslationText;